window.GS_SHIPPING_INSURANCE_MODULE = (function() {

  var MODULE = {
        
    config: {
      insuranceVariantId: 60732346040690
    },
    
    state: {
      path: null,
      requests: [],
      shipments: null
    },
    
    init: function() {
      this.state.path = this.registerPath();

      if (this.state.path === "multi") {
        this.multi.init();
        return;
      }
      
      if (this.state.path === "multi-cart") {
        this.multiCart.init();
        return;
      }
      
      if (this.state.path === "single") {
        this.single.init();
        return;
      }
    },

    registerPath: function () {
      var path = window.location.pathname;
      
      if (path.includes('a/gs/cart/confirm')) {
        return "multi";
      }
      
      if (path.includes('a/gs/cart')) {
        return "multi-cart";
      }
      
      return "single";
    },

    // ----------------------------------------------------------------------
    // 1. MULTI SHIPPING RATES PAGE
    // ----------------------------------------------------------------------
    multi: {
      
      init: function() {

        document.addEventListener('giftship.shipping.ready', function() {
          var shipments = window.GSSDK.shipments.get();
          MODULE.state.shipments = [ ...shipments ];
          MODULE.multi.handleInitialLoad();
        });
        
        document.addEventListener('giftship.shipping.rates-complete', function() {
          MODULE.flushProductRequests();
        });

        document.addEventListener('change', function(e) {
          if (e.target && e.target.id === 'gs-insurance-checkbox') {
            MODULE.state.requests = [];
            MODULE.multi.handleCheckboxToggle(e.target.checked);
          }
        });
      },

      handleInitialLoad: function() {
        MODULE.getCart()
        .then(function(cartData) {
          if (!cartData || !cartData.items) {
            return;
          }

          var hasValidInsurance = false;

          cartData.items.forEach(function(item) {
            if (item.variant_id !== MODULE.config.insuranceVariantId) {
              return;
            }

            var props = item.properties || {};
            var hasAddress = props._gs_a || props.Address;

            if (!hasAddress) {
              MODULE.state.requests.push({
                action: 'remove',
                id: item.key || item.variant_id
              });
            } else if (MODULE.multi.isOrphaned(props)) {
              MODULE.state.requests.push({
                action: 'remove',
                id: item.key || item.variant_id
              });
            } else {
              hasValidInsurance = true;
            }
          });

          var checkbox = document.getElementById('gs-insurance-checkbox');
          if (checkbox) {
            checkbox.checked = hasValidInsurance;
          }

        })
        .catch(function(err) {
          console.warn('Error during multi initial load cleanup:', err);
        });
      },

      handleCheckboxToggle: function(isChecked) {
        MODULE.getCart()
        .then(function(cartData) {
          
          if (!isChecked) {
            
            if (cartData && cartData.items) {
              cartData.items.forEach(function(item) {
                if (item.variant_id === MODULE.config.insuranceVariantId) {
                  MODULE.state.requests.push({
                    action: 'remove',
                    id: item.key || item.variant_id
                  });
                }
              });
            }

          } else {
            
            if (MODULE.state.shipments) {
              MODULE.state.shipments.forEach(function(shipment) {
                MODULE.multi.queueAddForShipment(shipment);
              });
            }

          }

          MODULE.flushProductRequests();

        })
        .catch(function(err) {
          console.warn('Error processing checkbox toggle:', err);
        });
      },

      getAddressString: function(props) {
        if (props.Address) {
          return props.Address;
        }
        if (props._gs_a && typeof props._gs_a === 'object') {
          return JSON.stringify(props._gs_a);
        }
        return props._gs_a || "";
      },

      isOrphaned: function(insuranceProps) {
        if (!MODULE.state.shipments) {
          return true; 
        }

        var targetAddress = MODULE.multi.getAddressString(insuranceProps);
        var isOrphan = true;

        MODULE.state.shipments.forEach(function(shipment) {
          var regularItems = shipment.variants.filter(function(v) {
            return v.variant_id !== MODULE.config.insuranceVariantId;
          });

          if (regularItems.length > 0) {
            var firstItemProps = regularItems[0].properties || {};
            var shipAddress = MODULE.multi.getAddressString(firstItemProps);

            if (shipAddress === targetAddress && targetAddress !== "") {
              isOrphan = false; 
            }
          }
        });

        return isOrphan;
      },

      queueAddForShipment: function(shipment) {
        var regularItems = shipment.variants.filter(function(v) {
          return v.variant_id !== MODULE.config.insuranceVariantId;
        });

        var hasInsurance = shipment.variants.some(function(v) {
          return v.variant_id === MODULE.config.insuranceVariantId;
        });

        if (regularItems.length === 0 || hasInsurance) {
          return;
        }

        var props = regularItems[0].properties || {};
        var hasAddress = props._gs_a || props.Address;

        if (hasAddress) {
          var newProps = {};
          if (props.Address) { newProps.Address = props.Address; }
          if (props._gs_a) { newProps._gs_a = props._gs_a; }

          MODULE.state.requests.push({
            action: 'add',
            id: MODULE.config.insuranceVariantId,
            properties: newProps,
            quantity: 1
          });
        }
      }
    },

    // ----------------------------------------------------------------------
    // 2. MULTI-CART PAGE
    // ----------------------------------------------------------------------
    multiCart: {
      
      init: function() {
        MODULE.getCart()
        .then(function(cartData) {
          if (!cartData.items || cartData.items.length === 0) {
            sessionStorage.removeItem('gs_insurance_reloaded');
            return;
          }

          var itemsToRemove = false;

          cartData.items.forEach(function(item) {
            if (item.variant_id === MODULE.config.insuranceVariantId) {
              MODULE.state.requests.push({
                action: 'remove',
                id: item.key || item.variant_id
              });
              itemsToRemove = true;
            }
          });

          if (!itemsToRemove) {
            sessionStorage.removeItem('gs_insurance_reloaded');
            return;
          }

          MODULE.flushProductRequests()
          .then(function() {
            var lastReload = sessionStorage.getItem('gs_insurance_reloaded');
            var now = Date.now();
            
            // Check if the last reload was within the last 15 seconds
            if (lastReload && (now - parseInt(lastReload, 10) < 15000)) {
              console.warn('Safety check: Prevented infinite reload loop.');
              sessionStorage.removeItem('gs_insurance_reloaded');
            } else {
              sessionStorage.setItem('gs_insurance_reloaded', now.toString());
              window.location.reload();
            }
          });

        })
        .catch(function(err) {
          console.warn('Error fetching cart in multi-cart:', err);
        });
      }
    },

    // ----------------------------------------------------------------------
    // 3. SINGLE/DRAWER PAGE
    // ----------------------------------------------------------------------
    single: {
      
      init: function() {
        MODULE.getCart()
        .then(function(cartData) {
          if (!cartData.items || cartData.items.length === 0) {
            return;
          }

          cartData.items.forEach(function(item) {
            if (item.variant_id === MODULE.config.insuranceVariantId) {
              var props = item.properties || {};
              
              if (props._gs_a || props.Address) {
                MODULE.state.requests.push({
                  action: 'remove',
                  id: item.key || item.variant_id
                });
              }
            }
          });

          MODULE.flushProductRequests();

        })
        .catch(function(err) {
          console.warn('Error fetching cart in single:', err);
        });
      }
    },

    // ----------------------------------------------------------------------
    // GLOBAL UTILITIES
    // ----------------------------------------------------------------------
    getCart: function() {
      return fetch('/cart.js')
      .then(function(res) {
        return res.json();
      });
    },

    changeCart: function(formData) {
      return fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
      .then(function(res) {
        return res.json();
      });
    },

    addProducts: function(formData) {
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
      .then(function(res) {
        return res.json();
      });
    },
 
    flushProductRequests: function() {

      if (!MODULE.state.requests.length) {
        return Promise.resolve("No updates needed");
      }
      
      var functions = MODULE.state.requests.map(function(request) {
        if (request.action === 'remove') {
          return MODULE.changeCart({
            id: request.id,
            quantity: 0
          });
        } else {
          return MODULE.addProducts({
            id: request.id,
            quantity: request.quantity,
            properties: request.properties
          });
        }
      });

      return new Promise(function(resolve, reject) {
        setTimeout(function() {
          Promise.all(functions)
            .then(resolve)
            .catch(reject);
        }, 1000); 
      });
    }

  };

  MODULE.init();

  return MODULE;
  
})();
